// extracted by mini-css-extract-plugin
export default {"formFullWidth":"EditHistoricInput_formFullWidth__MFcFL","interventionId":"EditHistoricInput_interventionId__OrRpH"};